import { atom } from "recoil";

export const currentPathState = atom({
  key: "currentPathState",
  default: "",
});
